import React from "react";
import { MyCafeteriaVbkApplicationCardPrint } from "my-cafeteria/components";

interface MyCafeteriaVbkApplicationPrintProps {
  applicationDate: string;
  employeeName: string;
  idNumber: string;
  contractCode: string;
  currentYear?: number;
}

export class MyCafeteriaVbkApplicationPrint extends React.PureComponent<MyCafeteriaVbkApplicationPrintProps> {
  render() {
    const {
      applicationDate,
      employeeName,
      idNumber,
      contractCode,
      currentYear,
    } = this.props;
    return (
      <MyCafeteriaVbkApplicationCardPrint
        applicationDate={applicationDate}
        employeeName={employeeName}
        idNumber={idNumber}
        contractCode={contractCode}
        currentYear={currentYear}
      />
    );
  }
}

export default MyCafeteriaVbkApplicationPrint;
